export default "__VITE_ASSET__CcM1$oSC__"